import { render, staticRenderFns } from "./RequestLists.vue?vue&type=template&id=6638ea22&scoped=true&"
import script from "./RequestLists.vue?vue&type=script&lang=js&"
export * from "./RequestLists.vue?vue&type=script&lang=js&"
import style0 from "./RequestLists.vue?vue&type=style&index=0&id=6638ea22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6638ea22",
  null
  
)

export default component.exports